// extracted by mini-css-extract-plugin
export default {"cta":"Cta_cta__x7Nh0"};